import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/src/app/(privacyAndTerms)/terms-and-condition/page.tsx");
